import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

const mobileBreakpoint = 'sm'

export const useOrdersListPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    visuallyHidden: {
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: 'hidden',
      clip: 'rect(0,0,0,0)',
      whiteSpace: 'nowrap',
      border: 0,
    },
    queryParamsHolder: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      maxWidth: '100%',
      [theme.breakpoints.down(mobileBreakpoint)]: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
        alignItems: 'end',
        width: '100%',
      },
    },
    mobileControls: {
      width: '100%',
      marginBottom: theme.spacing(1),
    },
    mobileSelect: {
      [theme.breakpoints.down(mobileBreakpoint)]: {
        width: '100% !important',
        minWidth: '0 !important',
        maxWidth: '100% !important',
        '& label': {
          display: 'none',
        },
        '& .MuiOutlinedInput-root': {
          minHeight: 36,
          maxWidth: '100%',
        },
        '& .MuiSelect-select': {
          minHeight: 36,
          paddingTop: 0,
          paddingBottom: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
    },
    emptyState: {
      padding: theme.spacing(6, 2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      [theme.breakpoints.down(mobileBreakpoint)]: {
        padding: theme.spacing(4, 1.5),
      },
    },
  })
)
